/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface License
 */
export interface License {
    /**
     * 
     * @type {boolean}
     * @memberof License
     */
    academic?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof License
     */
    rosetta?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof License
     */
    foldx?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof License
     */
    modeller?: boolean;
}

/**
 * Check if a given object implements the License interface.
 */
export function instanceOfLicense(value: object): value is License {
    return true;
}

export function LicenseFromJSON(json: any): License {
    return LicenseFromJSONTyped(json, false);
}

export function LicenseFromJSONTyped(json: any, ignoreDiscriminator: boolean): License {
    if (json == null) {
        return json;
    }
    return {
        
        'academic': json['academic'] == null ? undefined : json['academic'],
        'rosetta': json['rosetta'] == null ? undefined : json['rosetta'],
        'foldx': json['foldx'] == null ? undefined : json['foldx'],
        'modeller': json['modeller'] == null ? undefined : json['modeller'],
    };
}

export function LicenseToJSON(json: any): License {
    return LicenseToJSONTyped(json, false);
}

export function LicenseToJSONTyped(value?: License | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'academic': value['academic'],
        'rosetta': value['rosetta'],
        'foldx': value['foldx'],
        'modeller': value['modeller'],
    };
}

